import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { IconHelp, Tooltip } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './UnsetOption.module.scss';

const cx = classnames.bind(styles);

export const UnsetOption: FC = memo(() => {
  const { t } = useTranslation();
  const container = useGlobalContainerRef();

  return (
    <div className={cx('option-container')}>
      <span>{t('received_invoice_reconciliation_status_unset')}</span>
      <Tooltip
        title={t('received_invoice_reconciliation_status_unset_tooltip')}
        placement='right'
        getPopupContainer={container}
      >
        <button
          type='button'
          className={cx('icon-container')}
          aria-label={t('received_invoice_reconciliation_status_unset_tooltip')}
          onClick={(e) => e.stopPropagation()}
        >
          <IconHelp size={14} />
        </button>
      </Tooltip>
    </div>
  );
});
UnsetOption.displayName = 'UnsetOption';
